(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"));
	else if(typeof define === 'function' && define.amd)
		define("css-animator", ["@angular/core"], factory);
	else if(typeof exports === 'object')
		exports["css-animator"] = factory(require("@angular/core"));
	else
		root["css-animator"] = factory(root["ng"]["core"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__angular_core__) {
return 